(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pads-bad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var sections = scope.querySelectorAll('.pads-section[data-reveal="true"]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      sections.forEach(function (sec) {
        if (sec.dataset.padsInit) return;
        sec.dataset.padsInit = '1';
        if (reduce) return;

        sec.classList.add('js-reveal');
        var cards = sec.querySelectorAll('.pads-card');

        if (!('IntersectionObserver' in window)) {
          cards.forEach(function (c) { c.classList.add('in'); });
          return;
        }

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('in');
              io.unobserve(en.target);
            }
          });
        }, { threshold: 0.15 });

        cards.forEach(function (c) { io.observe(c); });
      });
    }

    if (document.readyState !== 'loading') {
      init(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
